import React, { PropTypes } from 'react';
import cx from './CardHeader.scss';
import withStyles from 'decorators/withStyles';
import Icon from 'components/Icon';

@withStyles(cx)
export default class CardHeader extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    onNextClick: PropTypes.func,
    onPrevClick: PropTypes.func,
    next: PropTypes.string,
    prev: PropTypes.string,
  };

  render() {
    const { children, onNextClick, onPrevClick, next, prev } = this.props;

    return (
      <div className={cx('main')}>
        {children}

        {(onNextClick || next) &&
          <a onClick={onNextClick} href={next} className={cx('nav', ['next'])}>
            <Icon type="nav-fwd-thin" />
          </a>
        }
        {(onPrevClick || prev) &&
          <a onClick={onPrevClick} href={prev} className={cx('nav', ['prev'])}>
            <Icon type="nav-fwd-thin" />
          </a>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/react/components/CardHeader/CardHeader.js